/** Used to lookup unminified function names. */
var realNames = {};

export default realNames;



//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/~/lodash-es/_realNames.js
// module id = 3470
// module chunks = 0